import React, { useEffect, useState } from 'react'
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import VerticalTable from '../../components/verticalTable';
import LineChart from '../../components/chartTypes/lineChart';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';
import { flowRatesByBranchEwi } from '../../services/flowRates';

const FlowRatesTamilNadu = () => {
    const { t } = useTranslation();
     
    
 
     const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>(() => ({
             periodWithOutDay: ["month"],
             state: ["31"], 
             fromDate: [sixMonthsAgoFormatted],
             toDate: [twoDaysAgoFormatted]
             }));
         
     const filters = [
        { key: "state", type: "select", label: t("filters.state"), isDisabled: true },
        // { key: "territory", type: "select", label: t("filters.territory") },
        { key: "cluster", type: "select", label: t("filters.cluster") },
        { key: "branch", type: "select", label: t("filters.branch") },
        { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period"), isDisabled: true },
        { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
        { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
      ];
 
     const [applyFilter, setApplyFilter] = useState<boolean>(false);
     // const [portfolioSummary, setPortfolioSummary] = useState<any[]>([]);
     const [portfolioSummary, setPortfolioSummary] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
         headers: [],
         data: [],
     });
     const [principalDPDEwi, setPrincipalDPDEwi] = useState<{ headers: string[]; data: { category: string; values: string[] }[] }>({
         headers: [],
         data: [],
     });
     const [portfolioMovement, setPortfolioMovement] = useState<any[]>([]);
     const [loading, setLoading] = useState<boolean>(true);
     const [principalDPDEwiLoading, setPrincipalDPDEwiLoading] = useState<boolean>(true);
     const [error, setError] = useState<string | null>(null);
     const [sampleData, setSampleData] = useState<{ category: string; values: string[] }[]>([]);
     const [period, setPeriod] = useState<any[]>([]);
     
 
 
     const generateFlowRatesByBranchEwi= async () => {
            setLoading(true)
            try {
            const response = await flowRatesByBranchEwi(selectedFilters); // Call the API function
            let period = ["", ...response.data.map((obj: any) => obj.period)]
            let flowBucket = response.data.map((obj: any) => obj.flow_bucket)
    
            const apiData = response.data; // from your API
    
                // Use a Map to accumulate flow values by flow category
                const flowMap = new Map<string, string[]>();
    
                apiData.forEach((periodEntry : any) => {
                periodEntry.flow_bucket.forEach((bucket: any) => {
                    // Normalize the flow name to match your sample format (e.g., "01. C -> X")
                    const flowLabel = bucket.flow.trim().toLowerCase().replace(/\b\w/g, (c: any) => c.toUpperCase());
    
                    if (!flowMap.has(flowLabel)) {
                    flowMap.set(flowLabel, []);
                    }
    
                    flowMap.get(flowLabel)?.push(bucket.flow_value_percentage.toString());
                });
                });
    
                // Convert Map to desired array format
                const sampleData = Array.from(flowMap.entries()).map(([category, values]) => ({
                    category,
                    values
                }));
    
                setSampleData(sampleData)
                setPeriod(period)
    
    
            } catch (err) {
            setError("Failed to fetch users");
            console.error(err);
            } finally {
                setLoading(false);
            }
        };

     const handleFilterChange = (updatedValues: Record<string, string[]>) => {
         setSelectedFilters(updatedValues);
         };
 
     const handleCancelClick = () => {
         setSelectedFilters({
             periodWithOutDay: ["month"],
             state: ["31"], //tamilnadu
             fromDate: [sixMonthsAgoFormatted],
             toDate: [twoDaysAgoFormatted]
         })
         setApplyFilter(!applyFilter)
         }

     const getColorForCategory = (category: string): string => {
        // const colorMap: Record<string, string> = {
        //     "00. C -> X": "#70e000",
        //     "01. X -> 30": "#ff595e",
        //     "02. 30 -> 60": "#1982c4",
        //     "03. 60 -> 90": "#6a4c93",
        //     "04. 90 -> 120": "#f72585",
        //     "05. 120 -> 150": "#3a86ff",
        // };
        // return colorMap[category] || "#000"; // fallback color
        const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
        return randomColor;
     };
 
     useEffect(() => {
        generateFlowRatesByBranchEwi();
     }, [applyFilter]);
 
    const sampleHeaders = ["","Jun 24", "Jul 24", "Aug 24", "Sep 24", "Oct 24", "Nov 24", "Dec 24", "Jan 25"];

    const sampleData1 = [
      { category: "01. C -> X", values: ["10", "15", "12", "20", "18", "25", "30", "22"] },
      { category: "02. X -> 30", values: ["5", "8", "6", "10", "12", "15", "18", "14"] },
      { category: "03. 30 -> 60", values: ["7", "10", "9", "13", "15", "18", "22", "17"] },
      { category: "04. 60 -> 90", values: ["3", "5", "4", "6", "8", "10", "12", "9"] },
      { category: "05. 90 -> 120", values: ["7", "10", "9", "13", "15", "18", "22", "17"] },
      { category: "06. 120 -> 150", values: ["3", "5", "4", "6", "8", "10", "12", "9"] },
    ];


   return (
     <div>
         {/* Page Content */}
         <div className="page-content">
             {/* Dynamic Grey Header */}
             <div className="header">
             {t('flowratesBranch.flowRatesTamilNadu.pageTitle')}
             </div>
 
             <div className="content px-3">
                 <MultiSelectCheckboxGroup 
                 filters={filters} 
                 selectedValues={selectedFilters} 
                 onChange={handleFilterChange} 
                 isLoading={[loading]}
                 buttons={[
                    { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
                    { label: t("buttons.cancel"), onClick: handleCancelClick },
                    { label: t("buttons.download"), onClick: () => alert("Download triggered") },
                  ]}
                 />
             </div>
           
             <div className="p-2 me-3">
                 <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', fontStyle: 'normal', textAlign: "start", paddingLeft: "15px", color: '#14213d',}}>{t('flowratesBranch.flowRatesTamilNadu.Flow Rates Tamil Nadu - EWI')}</h2>
                 <VerticalTable headers={period} data={sampleData} loading={loading}/>
 
             </div>
             <div className="mt-1 p-2">
                 <LineChart 
                     title={t('flowratesBranch.flowRatesTamilNadu.title')}
                     labels={period.slice(1)}
                    //  dataSets={[
                    //      { label: "%30+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%30+ DPD")?.percentage || 0), borderColor: "#70e000" },
                    //      { label: "%60+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%60+ DPD")?.percentage || 0), borderColor: "#003f88" },
                    //      { label: "%90+ DPD", data: portfolioMovement.map(item => item.dpd_buckets.find((bucket : any) => bucket.bucket_name === "%90")?.percentage || 0), borderColor: "#FF5733" },                  
                    //  ]}
                     dataSets={sampleData.map(item => ({
                        label: item.category,
                        data: item.values.map(value => parseFloat(value)), // convert string to number
                        borderColor: getColorForCategory(item.category), // custom function to assign colors
                     }))}
                     xLabel={t('flowratesBranch.flowRatesTamilNadu.xLabel')}
                     yLabel={t('flowratesBranch.flowRatesTamilNadu.yLabel')}
                 />
             </div>
         </div>
     </div>
   )
 }

export default FlowRatesTamilNadu
